<template>
  <div class="insider-div01 footerHintBox">
    <div class="row row-cols-1 row-cols-lg-2">
      <div class="col">
        <figure class="mo">
          <img alt="sm" src="static/static/picture/get_started_image.png">
        </figure>
      </div>
      <div class="col">
        <h6 class="text-white">提高您的工作效率 </h6>
        <h2 class="text-white">我们拥有500多位信任客户的实际案例，他们通过使用我们的服务，极大地改善了日常工作效率。
        </h2>

        <a data-bs-toggle="modal" data-bs-target="#registerModal" class="btn btn-subm">
          立即开始 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
            fill="currentColor" class="bi bi-arrow-up-right-square-fill" viewbox="0 0 16 16">
            <path
              d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707z">
            </path>
          </svg> </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>

<style scoped lang="less">
@media screen and (max-width: 991px) and (min-width: 920px) {
  .footerHintBox {
    padding: 30px;
    height: 250px;

    h2 {
      font-size: 24px;
    }

    .mo {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) and (min-width: 667px) {
  .footerHintBox {
    height: 300px;
  }
}

@media screen and (max-width: 393px) {
  .footerHintBox {
    height: 340px;
  }
}
</style>
